<template>
    <div>
        <CCardBody>
            <div class="text-right btngroup">
                <CButton
                    class="deleteBtn"
                >
                Delete
                </CButton>
                <CButton
                    class="addBtn"
                    @click="showModal"
                >
                Create
                </CButton>
            </div>
            <!-- <b-table class="mt-2" striped hover :items="steps" :fields="headers"></b-table> -->
            <CDataTable
                :items="steps"
                :fields="headers"
                table-filter
                items-per-page-select
                :items-per-page="5"
                hover
                sorter
                pagination
                >
                <template #actions="{item}">
                    <td>
                        <delete class="delete_step ml-2" @click="deleteStep(item.id)" fillColor="#E30000" :id="item.id" /> 
                    </td>
                </template>
            </CDataTable>
            <b-modal id="stepsModal" size="sm" no-close-on-backdrop  hide-footer>
                <template #modal-title>
                    <span>Create Step</span>
                </template>
                <CRow>
                    <CCol class="col-md-12">
                        <CInput
                        type="text"
                        name="name"
                        v-model="name"
                        v-validate="{required: true}"
                        placeholder="Enter step name"
                        >
                        </CInput>
                        <div v-if="errors && errors.first('name')" class="error_msg">
                            Step name is required
                        </div>
                        <CButton
                            color="success"
                            class="mt-2 w-100 float-right"
                            @click="saveStep"
                        >
                           Save
                        </CButton>
                    </CCol>
                </CRow>
            </b-modal>
        </CCardBody>
    </div>
</template>
<script>
import Delete from 'vue-material-design-icons/Delete.vue';
export default {
    components:{
        Delete,
    },
    data () {
        return {
            stepModal: false,
            name: '',
            headers: [
                {key: 'label', sortable: true,},
                {key: 'actions', label: 'Actions',},
            ],
            steps: [],
        }
    },
    async created(){
        await this.$store.dispatch("getSteps");
        this.steps = this.$store.getters.getSteps;
    },
    computed:{
        getSteps(){
            return this.$store.getters.getSteps;
        }
    },
    methods: {
        showModal(){
            this.$bvModal.show("stepsModal");
        },
        async saveStep(){
            let valid = await this.$validator.validate();
            if(valid){
                try{
                    await this.$store.dispatch("addStep", this.name);
                    this.steps = this.$store.getters.getSteps;
                    this.$bvModal.hide("stepsModal");
                    this.name = '';
                    this.showToast("Step created successfully", "SUCCESS");
                }catch(err){
                    console.log("err", err);
                }
            }
        },
        async deleteStep(id){
            try{
                await this.$store.dispatch("deleteStep", id);
                this.steps = this.$store.getters.getSteps;
                this.showToast("Step deleted successfully", "SUCCESS");
            }catch(err){
                console.log("Errror", err)
            }
        }
    },
}
</script>
<style type="scss">
    .delete_step{
        cursor: pointer;
    }
</style>